module.exports = __webpack_public_path__ + "static/img/2796d57bd27c219506ebafa0bee7503.23593d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/images/2796d57bd27c219506ebafa0bee7503.jpg
// module id = U4fZ
// module chunks = 45